import { defineComponent as _defineComponent } from 'vue'
import OfferGoalsCreate from "@/components/offers/offer/OfferGoalsCreate.vue";
import OfferGoals from "@/components/offers/offer/OfferGoals.vue";
import { OfferSingle } from "@/services/offers/OfferSingle";
import { onMounted, ref, watchEffect } from "vue";
import { useRoute, useRouter } from "vue-router/composables";
import { IOfferGoal } from "@/api/types/offers";
import isEqual from "lodash-es/isEqual";
import { useOfferDetailStore } from "@/store_v3/offerCard";
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";
import { storeToRefs } from "pinia";
import { showServerError } from "@/utils";
import { canEditOffers } from "@/utils/checkRole";

interface Props {
    offer: OfferSingle;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferGoalsTab',
  props: {
    offer: null
  },
  setup(__props: any) {

const props = __props as {
    offer: OfferSingle;
}


const route = useRoute();
const router = useRouter();
const { isCreateModeGoals, isEditModeGoals, isUpdateGoals } = storeToRefs(useOfferDetailStore());
const { setIsEditModeGoals, setIsUpdateOffer, setIsUpdateGoals, setIsCreateModeGoals } = useOfferDetailStore();

onMounted(() => {
    checkEditQuery();
});

// -- Create mode
const goalsComp = ref(null);

watchEffect(() => {
    isCreateModeGoals.value && enableCreateMode();
});

const enableCreateMode = () => {
    const params = { ...route.query, is_create_goals: true };
    props.offer.updateQueryString(params);
};

const disableCreateMode = () => {
    setIsCreateModeGoals(false);
    router.replace({ query: { 'tab': 'tab-goals' } });
    setTimeout(() => {
        goalsComp.value.filterStatus.select = '';
        goalsComp.value.status = '';
    }, 100);
};

const checkEditQuery = () => {
    const isCreate = route.query.is_create_goals === 'true' && canEditOffers();
    setIsCreateModeGoals(isCreate);
};

// -- Edit mode
const isLoading = ref(false);

watchEffect(() => {
    isUpdateGoals.value && editInfo();
});
watchEffect(() => {
    isEditModeGoals.value && cancelEdit();
});

const editInfo = async () => {
    try {
        isLoading.value = true;
        const resList = findModifiedItems(props.offer.goals, goalsComp.value.goalsItems);
        const isUpdate = await props.offer.editGoals(resList);
        isUpdate && setIsUpdateOffer(true);
        setIsEditModeGoals(false);
        setIsUpdateGoals(false);
    } catch (err) {
        showServerError(err, 'Ошибка обновления цели');
    } finally {
        isLoading.value = false;
    }
};

const cancelEdit = () => {
    goalsComp.value.goalsItems = JSON.parse(JSON.stringify(props.offer.goals));
};

const findModifiedItems = (original: IOfferGoal[], edited: IOfferGoal[]): IOfferGoal[] => {
    const modifiedItems: IOfferGoal[] = [];

    edited.forEach(editedItem => {
        const originalItem = original.find(item => item.id === editedItem.id);

        if (!originalItem) return;

        editedItem.revenue!.amount = Number(editedItem.revenue!.amount);
        editedItem.payout!.amount = Number(editedItem.payout!.amount);
        delete originalItem.payout_percent;
        delete editedItem.payout_percent;

        if (!isEqual(originalItem, editedItem)) {
            editedItem.payout!.amount = Number(editedItem.payout!.amount.toFixed(2));
            modifiedItems.push(editedItem);
        }
    });

    return modifiedItems;
};

return { __sfc: true,props, route, router, isCreateModeGoals, isEditModeGoals, isUpdateGoals, setIsEditModeGoals, setIsUpdateOffer, setIsUpdateGoals, setIsCreateModeGoals, goalsComp, enableCreateMode, disableCreateMode, checkEditQuery, isLoading, editInfo, cancelEdit, findModifiedItems, OfferGoalsCreate, OfferGoals, BaseEditableCard }
}

})